import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { HotelPaginationPropertiesType } from "./hotel-pagination.types";
const PAGE_SIZE = 20;
export const useLoadMore = properties => {
  const $ = _c(7);
  const {
    loading,
    pages,
    setPages,
    totalCount
  } = properties;
  const sentinelReference = useRef(null);
  const lockReference = useRef(false);
  const timeoutReference = useRef(null);
  let t0;
  let t1;
  if ($[0] !== loading || $[1] !== pages || $[2] !== setPages || $[3] !== totalCount) {
    t0 = () => {
      const sentinel = sentinelReference.current;
      if (!sentinel || loading) {
        return;
      }
      const maxPage = Math.ceil(totalCount / PAGE_SIZE);
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        const currentPage = pages.at(-1) || 1;
        const hasMorePage = maxPage > currentPage;
        if (!entry?.isIntersecting || !hasMorePage || lockReference.current) {
          return;
        }
        lockReference.current = true;
        timeoutReference.current = setTimeout(() => {
          setPages(state => {
            const nextPage = currentPage + 1;
            if (state.includes(nextPage)) {
              return state;
            }
            return [...state, nextPage].sort(_temp);
          });
          lockReference.current = false;
        }, 300);
      }, {
        rootMargin: "200px"
      });
      observer.observe(sentinel);
      return () => {
        observer.disconnect();
        if (timeoutReference.current) {
          clearTimeout(timeoutReference.current);
        }
        lockReference.current = false;
      };
    };
    t1 = [loading, pages, setPages, totalCount];
    $[0] = loading;
    $[1] = pages;
    $[2] = setPages;
    $[3] = totalCount;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      reference: sentinelReference
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(firstPage, secondPage) {
  return firstPage - secondPage;
}